import {Component, ElementRef, NgZone, Renderer2, ViewChild} from '@angular/core';
import {
    Content,
    Header, Keyboard,
    NavController,
    NavParams,
    Select,
    ViewController
} from 'ionic-angular';
import {Observable} from 'rxjs';

import {CONFIG} from '../../../app/config';
import {LogadoService} from "../../../providers/logado-service";
import {
    ENUM,
    TAction,
    TBrandedTipo,
    TGaleriaModo,
    TGaleriaTipo,
    THotpageAnimate,
    THotpageContent,
    THotpageHistoria,
    THotpageFeedback,
    THotpageLogotype,
    TProfileTeam,
    TProdutoTipo,
    TImageModel,
    TImageSpace,
    TContatoTipo,
    TProdutoView,
    TPrecifyMenu,
    TLoginTipo,
} from "../../../app/enum";
import {TStatusBar, Util} from "../../../app/util";
import {MessageService} from '../../../providers/message-service';
import {ProfileAuthPage} from '../profile-auth/profile-auth';
import {HotspotService} from "../../../providers/hotspot-service";
import {YoutubeVideoPlayer} from "@ionic-native/youtube-video-player";
import {ProfilePagePage} from "../profile-page/profile-page";
import {SpotdayInfoPage} from "../spotday-info/spotday-info";
import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {VoucherInfoPage} from "../voucher-info/voucher-info";
import {DomSanitizer} from "@angular/platform-browser";
import {GaleriaMenuPage} from "../galeria-menu/galeria-menu";
import {ProfileMenuPage} from "../profile-menu/profile-menu";
import {ProfileBornPage} from "../profile-born/profile-born";
import {ModalActionPage} from "../modal-action/modal-action";
import {DataService} from "../../../providers/data-service";
import {TFilterOpera} from "../../../pipes/filter-field/filter-field";
import {MeritumMenuPage} from "../meritum-menu/meritum-menu";
import {HotspotMenuPage} from "../hotspot-menu/hotspot-menu";
import {BrandedHtmlPage} from "../branded-html/branded-html";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfileService} from "../../../providers/profile-service";
import {WebstorService} from "../../../providers/webstor-service";
import {ProdutoMenuPage} from "../produto-menu/produto-menu";
import {getcard} from "../../../components/app-meritum/app-meritum";

@Component({
    selector: 'page-website-spot',
    templateUrl: 'website-spot.html',
    providers: [HotspotService, ProfileRepository, ProfileService, WebstorService]
})
export class WebsiteSpotPage {



    //I.C. ~> 
    workjob: number;
    workany: any;
    workfor: any;
    @ViewChild('workion') workion: Select;




    
    that: WebsiteSpotPage;

    ENUM: any = ENUM;
    config: any;
    getcard: Function;

    TProfileTeam: any = TProfileTeam;
    TGaleriaTipo: any = TGaleriaTipo;
    TGaleriaModo: any = TGaleriaModo;
    TBrandedTipo: any = TBrandedTipo;
    TFilterOpera: any = TFilterOpera;

    THotpageContent: any = THotpageContent;
    THotpageAnimate: any = THotpageAnimate;
    THotpageLogotype: any = THotpageLogotype;
    THotpageHistoria: any = THotpageHistoria;
    THotpageFeedback: any = THotpageFeedback;

    TImageModel: any = TImageModel;
    TImageSpace: any = TImageSpace;
    TContatoTipo: any = TContatoTipo;

    logado: any;
    websiteApp: boolean;

    tabmenu: boolean;
    rootdata: any;
    brandex: any;

    @ViewChild(Header) header: Header;
    @ViewChild(Content) content: Content;

    constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public util: Util, private keyboard: Keyboard,
                private ngZone: NgZone, private renderer: Renderer2, private element: ElementRef,
                private messageService: MessageService,
                public logadoService: LogadoService,
                public profileRepository: ProfileRepository,
                public hotspotService: HotspotService,
                public webstorService: WebstorService,
                public dataService: DataService,
                public youtube: YoutubeVideoPlayer, public sanitizer: DomSanitizer) {

        this.that = this;

        this.getcard = getcard;
        this.config = CONFIG;
        this.websiteApp = !!this.config.data.brandap;
        
        this.logado = this.logadoService.getAuth();

        this.brandex = this.navParams.get('brandex');
        this.tabmenu = this.navParams.get('tabmenu');
console.log(this.brandex);
        let hotspotID = this.navParams.get('hotspotID');
        this.hotspotLoad(hotspotID);

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    doScroll(event) {

        if (this.content.getScrollElement().scrollTop == 0) return;
        this.content.scrollTo(0, 0, 1000);
        this.hotspotLoad(this.rootdata.Hotspots[0].HotspotID);

    }

    corclass(hex: boolean, negative: boolean = false): string {

        let color = 'CorRoxa';
        if (this.rootdata) color = this.rootdata.Hotspots[0].Branded.BrandedCora;

        if (negative) color = this.config.negative(color);

        if (!hex) return color;
        if ( hex) return this.config.colors[color];

    }

    hotspotWork() {

        this.workfor = ['Gerência', 'Iluminador', 'Chefe de Bar', 'Estoquista', 'Bartender', 'Maitre', 'Garçom', 'Cumim', 'Limpeza', 'Caixa', 'Hostess', 'Segurança', 'Bombeiro'];
        if (this.workany) this.workany.unsubscribe();
        this.workany = this.workion.ionChange.subscribe(qtde => {
            let mailSpot = (this.rootdata.Hotspots[0].HotspotID == 1234 ? 'contato@lereveclub.com.br' : 'contato@thehistory.com.br');
            let mailText = 'mailto:' + mailSpot + '?Subject=Trabalhe Conosco - ' + this.workfor[qtde] + '&body=• Anexe seu curriculum:  %0D%0D' +
            'Se deseja adicionar algum comentário, aqui é o lugar';//  %0D http://thehistory.com.br';
            window.location.href = mailText;
        });

        setTimeout(() => this.workion.open(), 500);
        return;

    }

    hotspotLoad(hotspotID: number, hotblock?: THotpageContent, observer?) {

        this.rootdata = null;
        let logadoID = (!this.logado ? 0 : this.logado.Profile.ProfileID);

        let params = '&HotspotID=' + hotspotID + '&ProfileID=' + logadoID;
        this.logadoService.started(TAction.acPage, null, params)
            .subscribe(
                data => {

                    if (!data.Hotspots || !data.Hotspots.length) return;
                    this.rootdata = data;

                    // Pega Banners e Prepara/Filtra por Membercard
                    let ranking = 0;
                    let meritumID = (this.rootdata.Hotspots[0].Meritum || {}).MeritumID;
                    if (meritumID && this.logado) {
                        let meritum = this.logado.Meritums.find(mr => mr.MeritumID == meritumID);
                        let produto = this.getcard(meritum);
                        if (produto) ranking = produto.ProdutoLote;
                    }

                    this.rootdata.Galerias.Bannerx = [];
                    this.rootdata.Galerias.Banners.filter(banner => {
                        if (banner.GaleriaCard.length <= ranking || banner.GaleriaCard[ranking] == 1) {
                            this.rootdata.Galerias.Bannerx.splice(0, 0, banner);
                        }

                        banner.Value.forEach(filho => {
                            if (filho.GaleriaCard.length <= ranking || filho.GaleriaCard[ranking] == 1) {
                                this.rootdata.Galerias.Bannerx.splice(0, 0, filho);
                            }
                        });
                    });


                    this.util.showVideo = false;

                    if (!hotblock) this.alerta();
                    if (hotblock)  {
                        console.log('A');
                        let strblock = THotpageContent[hotblock].toLowerCase();
                        strblock = strblock.substr(0, 2) + '-' + strblock.substr(2);
                        console.log('B');
                        setTimeout(() => {
                            console.log('C', strblock);
                            const array = Array.from(this.content._elementRef.nativeElement.children[1].children[0].children) as any[];
                            const top = array.find(block => block.localName == strblock).offsetTop;
                            this.content.scrollTo(0, top, 0);
                            observer.next();
                            observer.complete();
                            console.log('D');
                        });

                    }

                    this.ngZone.run(() => {
                        setTimeout(() => {
                            this.messageService.get('website.rola').next({id: this.rootdata.Hotspots[0].HotspotID});
                        });
                    });

                    // Bordar flyer/fotos seguir cor da icon do blocked e mais grossa
                    if (this.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Stylecss) {

                        this.renderer.setAttribute(this.element.nativeElement, 'hs', this.rootdata.Hotspots[0].HotspotID);

                        let stylecss = this.rootdata.Hotspots[0].Branded.BrandedBody.Hspot.Stylecss;
                        let spotcode = this.rootdata.Hotspots[0].HotspotID;
                        stylecss = 'page-hotspot-page[hs=\'' + spotcode + '\'] ' + stylecss.split('}').join('} page-hotspot-page[hs=\'' + spotcode + '\'] ') + '{}';

                        const styleTagId = 'myweb-custom-style-' + this.rootdata.Hotspots[0].HotspotID;

                        const oldStyleTag = document.getElementById(styleTagId);
                        if (oldStyleTag) document.removeChild(oldStyleTag);

                        const styleTag = document.createElement('style');
                        styleTag.id = styleTagId;
                        styleTag.innerHTML = stylecss;
                        document.getElementsByTagName('head')[0].appendChild(styleTag);

                    }


                    /** Mykit **/
                    let template = this.rootdata.Hotspots[0].Branded.BrandedBody.Hspot;
                    template.Array.forEach(group => {
                        group.Array.forEach( block => {

                            //let source = 'https://www.w3schools.com/howto/rain.mp4';
                            //block.Ground.Movied = null;//{Source: source, Opacit: '10%', Scroll: 'Scroll', Grayed: true, Adjust: false};

                            //for (let keyname in block) {
                            //    for (let field in block[keyname]) {
                            //        if ((field == 'Fill' || field == 'Shape') && block[keyname][field]) {
                            //            block[keyname][field] = block[keyname][field].toLowerCase();
                            //        }
                            //    }
                            //}

                        });
                    });

                },
                erro => {

                    // pode deixar o usuário  navegar mesmo com erro aqui
                    if (observer) {
                        observer.next();
                        observer.complete();
                    }

                    this.util.alertResult(erro, () => this.dismiss());

                }
            );

    }

    findAnimate(blocked, tipo: THotpageAnimate) {

        //blocked.Animate = [
            //{Tipo: THotpageAnimate.haBlocki, Name: 'fadeInRight'},
            //{Tipo: THotpageAnimate.haEntire, Name: 'fadeInLeft'},
            //{Tipo: THotpageAnimate.haHeader, Name: 'fadeInDown'},
            //{Tipo: THotpageAnimate.haValued, Name: 'wobble'},
            //{Tipo: THotpageAnimate.haButton, Name: 'fadeInUp'},
            //{Tipo: THotpageAnimate.haGround, Name: 'flash'},
        //];

        return (blocked.Animate.find(a => a.Tipo == tipo) || {}).Name;

    }

    platenode(blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground', rootnome: 'Corone' | 'Cortwo' | 'Fonted' | 'Weight' | 'Textod' | 'Molded' | 'Fill' | 'Size' | 'Clip' | 'Shape' | 'Estilo' | 'Height' | 'Imaged' | 'Movied', rootfile: 'Source' | 'Padtop' | 'Padbot' | 'Sizing' | 'Opacit' | 'Scroll' | ' Grayed' = null, tag: number = 0, hpage: any = null, meritum: any = null): any {

        return this.config.platenode(this.rootdata.Hotspots[0].Branded, blocked, rootname, rootnome, rootfile, tag, hpage, meritum);

    }

    platestyled(blocked, rootname: 'Header' | 'Resume' | 'Button' | 'Spacer' | 'Ground') {

        return this.config.platestyled(blocked, rootname);

    }

    scrolldown() {

        this.content.scrollTo(0, window.innerHeight, 1000);

    }

    spacerStyle(blocked: any, square: boolean): any {

        let corone = this.platenode(blocked, 'Spacer', 'Corone');
        let cortwo = this.platenode(blocked, 'Spacer', 'Cortwo');
        let estilo = this.platenode(blocked, 'Spacer', 'Estilo');
        let height = this.platenode(blocked, 'Spacer', 'Height');

        let cone = this.config.colors[corone];
        let ctwo = this.config.colors[cortwo];

        if (!square) {
            if (estilo == 'Square') return {};
            if (estilo == 'Cropel') return {'clip-path': 'polygon(0 0, 100% ' + height + 'px, 100% 100%, 0 100%)', 'margin-top': '-' + height + 'px'};
            if (estilo == 'Croper') return {'clip-path': 'polygon(0 ' + height + 'px, 100% 0, 100% 100%, 0 100%)', 'margin-top': '-' + height + 'px'};
        }

        if (square) {
            if (estilo != 'Square') return {};
            return {height: height + 'px', 'background-image': 'linear-gradient(to right, ' + cone + ', ' + ctwo + ')'};
        }

    }

    onlyLoged(hotblock: THotpageContent): Observable<void> {

        return new Observable(observer => {

            let onResult = (reload) => {

                this.logado = this.logadoService.getAuth();

                if (!this.logado) {
                    observer.complete();
                    return;
                }

                if (reload) {
                    this.hotspotLoad(this.rootdata.Hotspots[0].HotspotID, hotblock, observer);
                    return;
                }

                observer.next();
                observer.complete();

            };

            let object = {etapa: 0, loginTipo: TLoginTipo.loStarting};
            if (!this.logado) this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe(() => onResult(true));
            if ( this.logado) onResult(false);

        });

    }

    alerta() {

        if (!this.rootdata.Galerias.Alertas.length) return;

        let object = {
            copyspot: this.rootdata,
            eventoID: 0,
            homeb: false,
            etapa: 3,
            selected: 0,
            galerias: this.rootdata.Galerias.Alertas,
            change: this.rootdata.Galerias.Alertas,
            galeriaTipo: TGaleriaTipo.gtAlerta,
            galeriaModo: TGaleriaModo.gmNenhum,
        };

        this.util.modalopen(GaleriaMenuPage, 'wide', true, object).subscribe(() => {
            this.messageService.get('website.rola').next({id: this.rootdata.Hotspots[0].HotspotID});
        });

    }

    entrakiOpen() {

        let object = {etapa: 4, paybook: this.rootdata.Paybooks[0]};
        this.util.modalopen(EntrakiOpenPage, 'wide', true, object).subscribe(
            data => {

                //Hotstar
                if (data && data.success) this.rootdata.Paybooks.splice(0, 1);

            });

    }

    profileBorn() {

        this.navCtrl.push(ProfileBornPage, {hotspotID: this.rootdata.Hotspots[0].HotspotID});

    }

    voucherMenu() {

        let objectData = {etapa: 0, voucherID: 0, profileID: this.logado.Profile.ProfileID, hotspotID: this.rootdata.Hotspots[0].HotspotID};
        this.util.modalopen(VoucherInfoPage, 'alto', false, objectData).subscribe();

    }

    externoOpen(banner) {

        if (!banner.GaleriaLink) return;

        this.util.open(banner.GaleriaLink, '_blank', '');

    }

    spotdayOpen(spotday) {

        let onDone = () => {
            let object = {etapa: 0, spotday: spotday};
            this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe();
        };

        this.onlyLoged(THotpageContent.hcEvento).subscribe(() => onDone());

    }

    spotdayText(spotday) {

        return (!spotday.Ambientes ? 'Aguarde em breve' : 'Obter Voucher');

    }

    brandedLogo() {

        if (this.rootdata.Hotspots[0].Meritum) this.meritumPage(null);

    }

    meritumPage(branded) {

        let onDone = () => {
            let meritum = {MeritumID: this.rootdata.Hotspots[0].Meritum.MeritumID};
            let object = {etapa: 1, rootile: this.logado, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone};
            this.navCtrl.push(MeritumMenuPage, object);
        };

        this.onlyLoged(THotpageContent.hcEvento).subscribe(() => onDone());

    }

    hotspotSign() {

        //let hotspotID = this.rootdata.Hotspots[0].HotspotID;
        //let brandex = this.rootdata.Hotspots[0].Branded;

        //Adquirir MyWeb

    }

    unidadePage() {

        /** OPEN **/
        let buttons: Array<any> = [];
        this.rootdata.Hotspots[0].Branded.BrandedSputs.forEach(spot => {
            buttons.push({text: spot.UnidadeNome, handler: () => this.hotspotLoad(spot.HotspotID)});
        });
        this.util.sheetOpen(buttons, 'HOTSPOT');

    }

    profileMenu(logado) {

        let onDone = () => {
            let object = {rootile: logado};
            this.navCtrl.push(ProfileMenuPage, object);
        };

        this.onlyLoged(THotpageContent.hcEvento).subscribe(() => onDone());

    }

    profilePage(profileID) {

        let object = {profileID: profileID};
        this.navCtrl.push(ProfilePagePage, object);

    }

    usuarioInfo(user) {

        //Visitar perfil
        if (!user.UsuarioHtml && this.logado) {
            this.profilePage(user.Profile.ProfileID);
            return;
        }

        let onOkey = (okey, that, data) => {
            this.profilePage(user.Profile.ProfileID);
            that.dismiss();
        };

        let data = {corcor: this.corclass(false), usuario: user};
        let objectData = {modalfull: false, modalinfo: this.config.modalinfo(this.util, 'memberuser', onOkey, onOkey, !!this.logado, data, null)};
        objectData.modalinfo.perfilfnd = user.Profile;
        this.util.modalopen(ModalActionPage, 'alto', false, objectData).subscribe();

    }

    produtoMenu() {

        let object = {etapa: 0, homeb: false, rootspot: null, produtoFull: false, produtoView: TProdutoView.pdPrecify, precifyMenu: TPrecifyMenu.pcNormal};
        this.navCtrl.push(ProdutoMenuPage, object);

    }

    mapaopen() {

        let onOkey = (okey, that, data) => {
            this.profileRepository.mapaopen(this.rootdata.Addresss[0].AddressPola, this.rootdata.Addresss[0].AddressPolo);
            that.dismiss();
        };


        //HTML Simple
        let objectData = {modalfull: true, modalinfo: this.config.modalinfo(this.util, 'animehtml', onOkey)};
        objectData.modalinfo.corcor = this.corclass(false);
        objectData.modalinfo.header = 'Onde estamos?';
        objectData.modalinfo.titulo = 'Anota ai...';
        objectData.modalinfo.action = {name: 'Abrir mapa', round: false, small: false, plus: null};
        //objectData.modalinfo.observ = observ;
        objectData.modalinfo.resumo = 'Somos de <b>' + this.rootdata.Addresss[0].Zipcity.ZipcityNome + ', ' + this.rootdata.Addresss[0].Zipcity.ZipcityZone + '</b> localizado no bairro <b><br>' +
                                      this.rootdata.Addresss[0].AddressVila + '</b> na <b>' + this.rootdata.Addresss[0].AddressNome + ', ' + this.rootdata.Addresss[0].AddressLote + '</b>.<br><br>' +
                                      'Reserva um tempinho e vem nos visitar. :)' + '<br><br>';
        if (this.contatoFind(TContatoTipo.coMail))
            objectData.modalinfo.resumo += 'Ahhh nosso e-mail é <b>' + this.contatoFind(TContatoTipo.coMail).ContatoUser + '</b>';

        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    callfone() {

        let contato = this.contatoFind(TContatoTipo.coChip);
        this.profileRepository.callfone(contato.ContatoUser);

    }

    contatoFind(contatoRede: TContatoTipo): any {

        return this.rootdata.Contatos.find(contato => contato.ContatoRede == contatoRede);

    }

    contatoOpen(contatoRede: TContatoTipo) {

        let contato = this.contatoFind(contatoRede);
        this.profileRepository.contatoOpen(contato, false);

    }

    settingOpen(onExec?, check?, event?) {

        if (event) event.stopPropagation();

        let onSpot = () => {
            let object = {etapa: 0, rootile: this.logado, hotspotID: this.rootdata.Hotspots[0].HotspotID, branded: this.rootdata.Hotspots[0].Branded};
            this.navCtrl.push(HotspotMenuPage, object);
        };

        let onLaye = () => {
            let copybran = this.util.deepCopy(this.rootdata.Hotspots[0].Branded);
            let object = {perfil: this.logado, rootbran: this.rootdata.Hotspots[0].Branded, copybran: copybran, keyplate: 'Hspot'};
            this.util.modalopen(BrandedHtmlPage, 'wide', true, object, null, null, null).subscribe();
        };

        let hotspot = (this.logado && this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        let layoute = (this.logado && this.logado.Profile.ProfileTeam >= TProfileTeam.mkPartner);

        if (onExec == 'onSpot') {
            if (check) return hotspot;
            onSpot();
            return;
        }

        if (onExec == 'onLaye') {
            if (check) return layoute;
            onLaye();
            return;
        }


        /** OPEN **/
        let buttons: Array<any> = [];
        if (hotspot) buttons.push({text: 'Hotspot', handler: () => onSpot()});
        if (layoute) buttons.push({text: 'Layoute', handler: () => onLaye()});
        this.util.sheetOpen(buttons, 'SETTING');

    }

    midiasee(galeriaTipo: TGaleriaTipo, galeria: any, $event: any = null, player: any = null, id: any = null) {

        this.util.midiasee(galeriaTipo, galeria, $event, player, id);

    }

    noticiaShow(noticia) {

        //HTML Simple
        let objectData = {modalfull: true, modalinfo: this.config.modalinfo(this.util, 'animehtml')};
        objectData.modalinfo.header = noticia.GaleriaNota;
        objectData.modalinfo.titulo = '<h6>' + noticia.GaleriaText + '</h6>';
        objectData.modalinfo.resumo = noticia.GaleriaHtml;

        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }

    galeriaView(galeriaID, galeriaTipo: TGaleriaTipo) {

        let loading = this.util.loadingDots();
        loading.present();

        let params = '&HotspotID=' + this.rootdata.Hotspots[0].HotspotID + '&GaleriaID=' + galeriaID;

        this.logadoService.started(TAction.acFoto, null, params)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let keyname = TGaleriaTipo[galeriaTipo].substring(2, 10) + 's';
                    let galerias = data.Galerias[keyname];

                    this.util.midiasee(galeriaTipo, galerias[0]);

                },
                erro => this.util.alertResult(erro)
            );

    }

    galeriaload(galeriaTipo: TGaleriaTipo) {

        //let keyname = TGaleriaTipo[galeriaTipo].substring(2, 10) + 's';

        //Notice Lista
        let object = {
            copyspot: this.rootdata,
            eventoID: 0,
            homeb: false,
            etapa: 1,
            selected: 0,
            galerias: null,//this.rootdata.Galerias[keyname],
            galeriaTipo: galeriaTipo,
            galeriaModo: TGaleriaModo.gmNenhum,
        };
        this.navCtrl.push(GaleriaMenuPage, object);

    }

    meritumCall() {

        let onDone = () => {
            let meritum = this.rootdata.Meritums[0];
            let object = {etapa: 88, rootile: this.logado, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone, shared: true};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();
        };

        this.onlyLoged(THotpageContent.hcMeritum).subscribe(() => onDone());

    }

    meritumOpen(textfind?, rootile?) {

        if (!rootile && !this.util.validaCNPF(textfind)) return;

        this.keyboard.close();
        this.keyboard.onClose(() => {

            if (rootile && !textfind) textfind = rootile.Profile.ProfileID;

            let meritum = {MeritumID: this.rootdata.Hotspots[0].Meritum.MeritumID};
            let object = {etapa: 4, rootile: rootile, meritums: [meritum], produtoTipo: TProdutoTipo.ptCard, copytums: null, textfind: textfind};
            this.util.modalopen(MeritumMenuPage, 'quad', true, object).subscribe();

        });

    }

    bannerchange() {

    }

    getSlidesPerView() {

        return window.innerWidth <= 700 ? 0.4635 : 1.0;

    }

    loreanopen() {

        this.util.open('https://www.lorean.com.br', '_blank', '');

    }

    dismiss() {

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/website-spot.ts